var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThanksSoilLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 319,
    height: 506,
    viewBox: "0 0 319 506",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M168.604 0.663086C142.314 16.3194 0.903809 97.9036 0.903809 97.9036V189.536L160.332 282.235V505.395H204.338L204.332 255.748L42.1909 161.46V122.648L168.596 49.4667C302.947 127.398 318.05 136.335 318.05 136.335V87.5891C255.475 51.7438 168.604 0.663086 168.604 0.663086Z",
    fill: "url(#paint0_linear_1_1460)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M123.822 142.17L276.752 231.431V310.22L250.086 325.696V378.737L318.039 339.326V203.157C264.976 172.344 168.513 116.171 168.513 116.171L123.822 142.17Z",
    fill: "url(#paint1_linear_1_1460)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M0.895508 312.931L114.25 378.738V325.697L0.895508 259.861V312.931Z",
    fill: "url(#paint2_linear_1_1460)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_1460",
    x1: 159.477,
    y1: 0.663086,
    x2: 168.024,
    y2: 388.585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08A98A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_1460",
    x1: 220.931,
    y1: 116.171,
    x2: 224.708,
    y2: 317.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08A98A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_1460",
    x1: 57.5726,
    y1: 259.861,
    x2: 58.8994,
    y2: 351.252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08A98A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThanksSoilLogo);
export default __webpack_public_path__ + "static/media/thanksSoilLogo.a3563bcc6297c0014a754f08012db638.svg";
export { ForwardRef as ReactComponent };